// src/utils/Functions.js
import { db } from '../firebase'; // Import Firestore
import { doc, getDoc, setDoc, updateDoc, collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

const apiKey = '7837c2a021msh419c1695e853662p1e524cjsne171fd94cdbc'; 



/**
 * Get user by username.
 * @param {string} uid - The uid of the user.
 * @returns {Promise<Object>} - User data.
 */
export const getUserByUid = async (uid) => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('id', '==', uid));
  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    throw new Error('No user found with this uid.');
  }

  const userDoc = querySnapshot.docs[0];
  return userDoc.data();
};


/**
 * Get user by email.
 * @param {string} email - The email of the user.
 * @returns {Promise<Object>} - User data.
 */
export const getUserByEmail = async (email) => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('email', '==', email));
  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    throw new Error('No user found with this email.');
  }

  const userDoc = querySnapshot.docs[0];
  return userDoc.data();
};

/**
 * Get user by username.
 * @param {string} username - The username of the user.
 * @returns {Promise<Object>} - User data.
 */
export const getUserByUsername = async (username) => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('username', '==', username));
  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    throw new Error('No user found with this username.');
  }

  const userDoc = querySnapshot.docs[0];
  return userDoc.data();
};

/**
 * Get friends by user UID.
 * @param {string} uid - The UID of the user.
 * @returns {Promise<Array>} - Array of friends' email addresses.
 */
export const getFriendsByUid = async (uid) => {
  const userDocRef = doc(db, 'users', uid);
  const userDoc = await getDoc(userDocRef);

  if (!userDoc.exists()) {
    throw new Error('No user found with this UID.');
  }

  const userData = userDoc.data();
  return userData.friends || [];
};

/**
 * Get account balance by UID.
 * @param {string} uid - The UID of the user.
 * @returns {Promise<number>} - Account balance.
 */
export const getAccountBalanceByUid = async (uid) => {
  const userDocRef = doc(db, 'users', uid);
  const userDoc = await getDoc(userDocRef);

  if (!userDoc.exists()) {
    throw new Error('No user found with this UID.');
  }

  const userData = userDoc.data();
  return parseFloat(userData.account_balance) || 0;
};

/**
 * Set account balance by UID.
 * @param {string} uid - The UID of the user.
 * @param {number} amount - The amount to set.
 * @returns {Promise<void>} - Void.
 */
export const setAccountBalanceByUid = async (uid, amount) => {
  const userDocRef = doc(db, 'users', uid);
  
  try {
    // Update the account_balance field
    await updateDoc(userDocRef, {
      account_balance: parseFloat(amount)
    });
    console.log(`Successfully updated balance for user ${uid} to ${amount}`);
  } catch (error) {
    console.error(`Error updating balance for user ${uid}:`, error);
    throw error;
  }
};

export const addToAccountBalanceByUid = async (uid, amount) => {
  const userDocRef = doc(db, 'users', uid);

  try {
    // Fetch the current document data
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      // Get the current balance
      const currentBalance = userDoc.data().account_balance || 0;

      // Calculate the new balance
      const newBalance = currentBalance + amount;

      // Update the account_balance field
      await updateDoc(userDocRef, {
        account_balance: parseFloat(newBalance)
      });

      console.log(`Account balance updated successfully for UID ${uid}. New balance: ${newBalance}`);
    } else {
      console.error(`No such document found for UID ${uid}.`);
    }
  } catch (error) {
    console.error(`Error updating account balance for UID ${uid}:`, error);
  }
};

export async function checkIfUserCanBet (uniqueId){
  const q = query(collection(db, "ActiveBets"), where("uniqueId", "==",uniqueId));
  const querySnapshot = await getDocs(q);
  var bets = [];
  var systemSettings = null;
  querySnapshot.forEach((doc) => {
      var tmp = doc.data()
      tmp["id"] = doc.id
      bets.push(tmp);
  });

  const q2 = query(collection(db, "SystemSettings"));
  const querySnapshot2 = await getDocs(q2);

  querySnapshot2.forEach((doc) => {
      var tmp = doc.data()
      systemSettings = tmp;
  });




  if(bets.length && systemSettings){
      var bet = bets[0];

      if(bet["accepted"] === "Yes"){
          alert("Someone already accepted this bet!", bet["accepted"])
          return false;
      }
      if(!systemSettings.betsAllowed){
          alert("Unable to accept this bet.", systemSettings.betsAllowed)
          return false;
      }

      return true
  }

  return false

}

export async function createTransaction(user_id, type, description, beforeBalance, afterBalance, amount, betDetails){
  const id = uuidv4();
  const transactionRef = doc(db, 'Transactions', id);
  var transactionData = {
      id: id,
      createdAt: new Date().toISOString(),
      user_id,
      type,
      amount,
      description,
      beforeBalance,
      afterBalance,
      betDetails
  }
  await setDoc(transactionRef, transactionData);
  
}

export async function removeCompletedBetsById(id) {
  const q = query(collection(db, "ActiveBets"), where("user_id", "==", id));
  const querySnapshot = await getDocs(q);

  const results = [];
  querySnapshot.forEach((docSnap1) => {
    let bet = docSnap1.data();
    bet["id"] = docSnap1.id;
    results.push({ bet, ref: docSnap1.ref });
  });

  const currentTime = new Date();

  for (const { bet, ref } of results) {
    const betTime = new Date(bet["bet_time"]);
    const expirationTime = new Date(betTime.getTime() + (60 * 60 * 1000));

    if (
      bet["status"] === "Created" &&
      bet["paid_out"] === "No" &&
      bet["accepted"] === "No" &&
      expirationTime < currentTime
    ) {
      try {
        const userRef = doc(db, "users", id);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
          console.error(`User ${id} not found`);
          continue;
        }

        const userData = userSnap.data();
        const currentBalance = parseFloat(userData.account_balance) || 0;
        const refundAmount = parseFloat(bet.wager_amount) || 0;
        const newBalance = currentBalance + refundAmount;

        console.log(
          `Refunding ${refundAmount} to ${id}. Old balance: ${currentBalance}, New balance: ${newBalance}`
        );

        // Update bet status
        await updateDoc(ref, {
          status: "Deleted",
          paid_out: "Yes",
          paid_out_at: new Date().toISOString(),
        });

        // Update balance
        await setAccountBalanceByUid(id, newBalance);

        // Record transaction
        await createTransaction(
          id,
          "Wager",
          "Remove Expired Wager",
          currentBalance,
          newBalance,
          refundAmount,
          bet
        );
      } catch (err) {
        console.error(`Error refunding expired bet for ${id}:`, err);
      }
    }
  }
}


// Test function to check for expired bets (for debugging)
export async function checkExpiredBetsForUser(uid) {
  try {
    const q = query(collection(db, "ActiveBets"), where("user_id", "==", uid));
    const querySnapshot = await getDocs(q);
    
    const currentTime = new Date();
    const expiredBets = [];
    
    querySnapshot.forEach((docSnap) => {
      const bet = docSnap.data();
      const betTime = new Date(bet["bet_time"]);
      // Add 1 hour buffer - bets expire 1 hour after game start time
      const expirationTime = new Date(betTime.getTime() + (60 * 60 * 1000)); // 1 hour in milliseconds
      
      if (bet["status"] === "Created" && bet["paid_out"] === "No" && bet["accepted"] === "No" && expirationTime < currentTime) {
        expiredBets.push({
          id: docSnap.id,
          wager_amount: bet.wager_amount,
          bet_time: bet.bet_time,
          expiration_time: expirationTime.toISOString(),
          time_until_expired: currentTime - expirationTime,
          home_team: bet.home_team,
          away_team: bet.away_team
        });
      }
    });
    
    console.log(`Found ${expiredBets.length} expired bets for user ${uid}:`, expiredBets);
    return expiredBets;
  } catch (error) {
    console.error(`Error checking expired bets for user ${uid}:`, error);
    return [];
  }
}

// Manual refund function for specific bet
export async function manualRefundBet(betId, userId) {
  try {
    console.log(`Manually refunding bet ${betId} for user ${userId}`);
    
    // Get the bet data
    const betRef = doc(db, "ActiveBets", betId);
    const betSnap = await getDoc(betRef);
    
    if (!betSnap.exists()) {
      throw new Error(`Bet ${betId} not found`);
    }
    
    const betData = betSnap.data();
    
    // Get current user balance
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);
    
    if (!userSnap.exists()) {
      throw new Error(`User ${userId} not found`);
    }
    
    const userData = userSnap.data();
    const currentBalance = parseFloat(userData.account_balance) || 0;
    const refundAmount = parseFloat(betData.wager_amount) || 0;
    const newBalance = currentBalance + refundAmount;
    
    console.log(`Refunding ${refundAmount} to user ${userId}. Old balance: ${currentBalance}, New balance: ${newBalance}`);
    
    // Update bet status
    await updateDoc(betRef, {
      status: "Deleted",
      refunded: true,
      refunded_at: new Date().toISOString()
    });
    
    // Update user balance
    await setAccountBalanceByUid(userId, newBalance);
    
    // Create transaction record
    await createTransaction(
      userId,
      "Wager",
      "Manual Refund - Expired Wager",
      currentBalance,
      newBalance,
      refundAmount,
      betData
    );
    
    console.log(`Successfully manually refunded ${refundAmount} to user ${userId}`);
    return { success: true, refundAmount, newBalance };
    
  } catch (error) {
    console.error(`Error manually refunding bet ${betId} for user ${userId}:`, error);
    throw error;
  }
}

export async function getAllSports() {
  const url = 'https://odds.p.rapidapi.com/v4/sports?all=true';
  const apiKey = '7837c2a021msh419c1695e853662p1e524cjsne171fd94cdbc'; 
  const options = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': apiKey, // Replace with your actual RapidAPI key
      'X-RapidAPI-Host': 'odds.p.rapidapi.com',
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Error fetching sports: ${response.statusText}`);
    }

    const data = await response.json();

    const sportsDocRef = doc(db, 'SportsCollection', 'AllSports');
    await setDoc(sportsDocRef, { sports: data });

    console.log("saved to fb: ");


    
    return data; // This will be the array of sports objects
  } catch (error) {
    console.error('Error fetching sports data:', error);
    return null; // Or handle the error as needed
  }
}


export async function fetchAndSaveScores(sportsKey) {
  try {
    const response = await fetch(`https://odds.p.rapidapi.com/v4/sports/${sportsKey}/scores?daysFrom=3`, {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': apiKey,
        'X-RapidAPI-Host': 'odds.p.rapidapi.com'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch scores: ${response.statusText}`);
    }

    const scores = await response.json();
    const fetchedScores = Array.isArray(scores) ? scores : [];

    const docRef = doc(collection(db, 'Scores'), sportsKey);
    const existingDoc = await getDoc(docRef);
    const existingScores = existingDoc.exists() ? (existingDoc.data()?.scores || []) : [];

    const scoresById = new Map();
    for (const item of existingScores) {
      if (item?.id) scoresById.set(item.id, item);
    }
    for (const item of fetchedScores) {
      if (!item?.id) continue;
      // Upsert latest API payload so completed/status flips are reflected.
      scoresById.set(item.id, item);
    }

    const mergedScores = Array.from(scoresById.values()).sort(
      (a, b) => new Date(b.commence_time || 0) - new Date(a.commence_time || 0)
    );

    await setDoc(
      docRef,
      {
        scores: mergedScores,
        totalFetched: fetchedScores.length,
        totalSaved: mergedScores.length,
        lastFetchedAt: new Date().toISOString(),
      },
      { merge: true }
    );

    return fetchedScores;

  } catch (error) {
    console.error('Error fetching and saving scores:', error);
  }
}

 export async function awardMyActiveBets(uid) {
  const paypalMode = (process.env.REACT_APP_PAYPAL_MODE || 'live').toLowerCase();
const paypalClientId = paypalMode === 'live'
  ? (process.env.REACT_APP_PAYPAL_LIVE_CLIENT_ID || process.env.REACT_APP_PAYPAL_CLIENT_ID)
  : (process.env.REACT_APP_PAYPAL_SANDBOX_CLIENT_ID || process.env.REACT_APP_PAYPAL_CLIENT_ID);

    // Query to get all active bets where the user is involved (either as the creator or acceptor)
    const betsQuery = query(
      collection(db, "ActiveBets"),
      where("status", "==", "Active"),
      where("accepted", "==", "Yes"),
      where("user_id", "==", uid) // or where("bet_acceptor_uid", "==", uid)
    );
  
    const betAcceptorQuery = query(
      collection(db, "ActiveBets"),
      where("status", "==", "Active"),
      where("accepted", "==", "Yes"),
      where("bet_acceptor_uid", "==", uid)
    );
  
    // Collect active bets
    const [userBetsSnapshot, acceptorBetsSnapshot] = await Promise.all([getDocs(betsQuery), getDocs(betAcceptorQuery)]);
    let activeBets = [];
  
    userBetsSnapshot.forEach((doc) => {
      let bet = doc.data();
      bet["id"] = doc.id;
      activeBets.push(bet);
    });
  
    acceptorBetsSnapshot.forEach((doc) => {
      let bet = doc.data();
      bet["id"] = doc.id;
      activeBets.push(bet);
    });
  
    // Query the Scores collection to find matching games for your bets
    const scoresSnapshot = await getDocs(collection(db, 'Scores'));
    let completedGames = [];
  
    scoresSnapshot.forEach((docSnap) => {
      let scoresData = docSnap.data();
      if (scoresData.scores) {
        completedGames = completedGames.concat(
          scoresData.scores.filter(game => game.completed === true && game.scores !== null)
        );
      }
    });
  
    // Loop through each active bet and check for a matching completed game
    activeBets.forEach(async (bet) => {
      const matchingGame = completedGames.find(game => game["id"] === bet["bet_id"]);
  
      if (matchingGame) {
        const scores = matchingGame["scores"];
        const gameWinner = parseInt(scores[0]["score"]) > parseInt(scores[1]["score"]) ? scores[0] : scores[1];
  
        // Determine who the winner is (yourself or the other person)
        const winnerUid = gameWinner["name"] === bet["user_pick"] ? bet["user_id"] : bet["bet_acceptor_uid"];
        console.log(`Game: ${matchingGame["id"]}, Winner: ${gameWinner["name"]}, Winner UID: ${winnerUid}`);
  
        // If the game is completed, award the bet to the winner
        const data = {
          paid_out: "Yes",
          winner: winnerUid,
          status: "Settled",
        };
  
        // Update the bet status to Settled
        await updateDoc(doc(db, 'ActiveBets', bet["id"]), data);
        console.log(`Bet settled. Winner UID: ${winnerUid}, Amount: ${parseFloat(bet["wager_amount"])}`);
  
        // Update user's balance and create a transaction
        try {
          const docRef = doc(db, "users", winnerUid);
          const docSnap = await getDoc(docRef);
  
          if (docSnap.exists()) {
            console.log("awarding ", bet.payout, " to ", winnerUid, " bet: ", bet)
            const userData = docSnap.data();
            createTransaction(winnerUid, "Wager", "Win Wager", parseFloat(userData.account_balance), parseFloat(userData.account_balance) + parseFloat(bet.payout), parseFloat(bet.wager_amount), bet);
            setAccountBalanceByUid(winnerUid, parseFloat(userData.account_balance) + parseFloat(bet.payout));
          }
        } catch (e) {
          console.log(e);
        }
      }
    });
  }

  export async function sendNotification(type, fromUsername, fromUid, toUid, content, path, profilePicUrl) {
    try {
      // Generate a unique key for the notification
      const notificationKey = `${fromUid}-${Date.now()}`;
  
      // Create the notification object
      const notification = {
        type,
        fromUsername,
        fromUid,
        toUid,
        content,
        path,
        profilePicUrl,
        createdAt: new Date().toISOString(), // Use Firestore's server timestamp
        key: notificationKey,
        read: false // Add read field, default to false
      };
  
      // Reference to the Notifications collection
      const notificationsRef = collection(db, 'Notifications');
  
      // Add the notification to Firestore
      await addDoc(notificationsRef, notification);
  
      console.log('Notification sent successfully');
    } catch (error) {
      console.error('Error sending notification:', error);
    }
  }

      


